<template>
  <div
    data-test="us-status-tag"
    :class="[
      'us-status-tag',
      `us-status-tag--semantic--${semantic}`,
      { 'us-status-tag--small': small }
    ]"
  >
    <p class="us-status-tag__label button--label">
      {{ label }}
    </p>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'USStatusTag',
  props: {
    label: {
      type: String,
      required: true
    },
    semantic: {
      type: String,
      default: 'none',
      validator: (value: string) => {
        return ['alert', 'error', 'info', 'none', 'success'].includes(value)
      }
    },
    small: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint';

.us-status-tag {
  border-radius: var(--border-radius--small);
  display: inline-block;
  max-width: 100%;
  padding: var(--spacing--8);
  text-align: center;
  white-space: nowrap;

  &--small {
    padding: var(--spacing--9);

    .us-status-tag__label {
      font-size: var(--font-size--z8);
    }
  }

  &--semantic--alert,
  &--semantic--none {
    background-color: var(--color--semantic--alert-4);
    color: var(--color--semantic--alert-1);
  }

  &--semantic--error {
    background-color: var(--color--semantic--error-4);
    color: var(--color--semantic--error-1);
  }

  &--semantic--info {
    background-color: var(--color--semantic--info-4);
    color: var(--color--semantic--info-1);
  }

  &--semantic--success {
    background-color: var(--color--semantic--success-4);
    color: var(--color--semantic--success-1);
  }
}
</style>
